import { useCallback } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { isLikelyAutomatedClient } from '../utils/isLikelyAutomatedClient';

export const useGoogleTagManager = () => {
  const sendDataToGTM = useGTMDispatch();
  const isAutomatedClient = isLikelyAutomatedClient();

  const trackEventInGoogleTagManager = useCallback(
    (eventName) => {
      if (isAutomatedClient) {
        return;
      }
      // send page view event to Google Tag Manager
      // because not supported in Segment
      sendDataToGTM({ event: 'page_view', page_title: eventName });
    },
    [isAutomatedClient, sendDataToGTM]
  );

  return { trackEventInGoogleTagManager };
};
